import { ConfigProvider, Layout } from 'antd';
import { observer } from 'mobx-react';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';
import { HeaderStore } from '../DataSource/Stores/HeaderStore';

function CabinetLayout() {
  const onClose = () => {
    HeaderStore.setOpenRight(false);
  };

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 990px)' });

  return (
    <ConfigProvider>
      <Layout>
        <div className="cabinet_block" style={{ padding: '24px' }}>
          <Outlet />
        </div>
      </Layout>
    </ConfigProvider>
  );
}
export default observer(CabinetLayout);
